import type { Ref } from 'react';
import { CheckIcon, SearchIcon } from './Icons';
import { MAP_CATEGORIES, type MapCategory } from '@/lib/ranchMap';

interface RanchMapToolbarProps {
  categories: MapCategory[];
  category: string;
  onCategory: (key: string) => void;
  query: string;
  onQuery: (value: string) => void;
  onFitAll: () => void;
  toolbarRef?: Ref<HTMLDivElement>;
}

export function RanchMapToolbar({
  categories,
  category,
  onCategory,
  query,
  onQuery,
  onFitAll,
  toolbarRef,
}: RanchMapToolbarProps) {
  const chips = categories.length > 0 ? categories : MAP_CATEGORIES;

  return (
    <div className="ranch-map-toolbar" ref={toolbarRef}>
      <div className="ranch-map-toolbar__search search-box">
        <SearchIcon />
        <label htmlFor="map-filter" className="visually-hidden">
          Search places on the map
        </label>
        <input
          id="map-filter"
          type="search"
          placeholder="Search the map"
          value={query}
          onChange={(e) => onQuery(e.target.value)}
          autoComplete="off"
        />
        <button type="button" className="ranch-map-toolbar__fit" onClick={onFitAll}>
          Fit all
        </button>
      </div>

      <div className="ranch-map-chips" role="tablist" aria-label="Category">
        {chips.map((c) => {
          const selected = category === c.key;
          return (
            <button
              key={c.key}
              type="button"
              role="tab"
              aria-selected={selected}
              className={`interest-chip ${selected ? 'interest-chip--on' : ''}`}
              onClick={() => onCategory(c.key)}
            >
              <CheckIcon checked={selected} />
              <span>{c.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
